import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ExtractTexturesPage } from './extract-textures.page';

const routes: Routes = [
  {
    path: 'extract-textures',
    component: ExtractTexturesPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExtractTexturesRoutingModule {}
